"use strict";
export function useIsUniswapXSupportedChain(chainId) {
  return false;
}
